import { Buttons } from '../../../controls/buttons';
import { Checkbox } from '../../../controls/checkbox';
import { Layouts } from '../../../controls/layouts';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';
import { Textbox } from '../../../controls/textbox';

@Component({
  selector: 'app-partner-onboarding-reopen-dialog',
  standalone: true,
  imports: [ModalDialogComponent, FormsModule, Buttons, Checkbox, Textbox, ModalDialogComponent, Layouts],
  templateUrl: './partner-onboarding-reopen-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './partner-onboarding-reopen-dialog.component.scss'
})
export class PartnerOnboardingReopenDialogComponent {
  private dialog = inject(NgbActiveModal);
  notifyPartner = false;
  notificationMessage = '';

  reopen() {
    if (this.notifyPartner) {
      this.dialog.close({ type: ReopenType.ReopenAndNotify, notificationMessage: this.notificationMessage });
    }

    this.dialog.close({ type: ReopenType.Reopen });
  }

  cancel() {
    this.dialog.close({ type: ReopenType.Cancel });
  }
}

export interface PartnerOnboardingReopenDialogResult {
  type: ReopenType;
  notificationMessage?: string;
}

export enum ReopenType {
  Reopen,
  ReopenAndNotify,
  Cancel
}
